import type { FC } from "react";
import { MultiSelect } from "primereact/multiselect";
import useFilterReset from "@/hooks/useFilterReset";
import type { SelectOption } from "@/pages/CampaignOverviewPage/charts/DeviceBrowserChart/useDeviceBrowserData";
import { multiSelectSearchPt } from "@/styles/multiSelectSearch.pt";
import { TEXT } from "@/constants/text";
import styles from "@/pages/CampaignOverviewPage/charts/DeviceBrowserChart/DeviceBrowserChart.module.css";

interface FilterSelectProps {
  filterPlaceholder: string;
  options: SelectOption[];
  placeholder: string;
  selectedItemsLabel: string;
  value: string[];
  onChange: (value: string[]) => void;
}

const FILTER_PILL_PT = {
  ...multiSelectSearchPt,
  root: { className: styles.filterPill },
  checkboxContainer: { className: styles.filterCheckboxContainer },
  item: { className: styles.filterItem },
  label: { className: styles.filterPillLabel },
  list: { className: styles.filterList },
  panel: { className: styles.filterPanel },
  trigger: { className: styles.filterPillTrigger },
  wrapper: { className: styles.filterWrapper },
};

// A searchable pill MultiSelect for one Device & Browser dimension.
const FilterSelect: FC<FilterSelectProps> = ({
  filterPlaceholder,
  options,
  placeholder,
  selectedItemsLabel,
  value,
  onChange,
}) => {
  const filterReset = useFilterReset();

  return (
    <MultiSelect
      aria-label={placeholder}
      emptyFilterMessage={TEXT.campaignOverview.deviceBrowser.noMatchesFound}
      filter
      filterPlaceholder={filterPlaceholder}
      filterTemplate={filterReset.filterTemplate}
      maxSelectedLabels={1}
      options={options}
      panelHeaderTemplate={filterReset.buildHeader}
      placeholder={placeholder}
      pt={FILTER_PILL_PT}
      selectedItemsLabel={selectedItemsLabel}
      value={value}
      onChange={(e) => onChange(e.value ?? [])}
      onFilter={filterReset.onFilter}
    />
  );
};

export default FilterSelect;
